import type { WabunkaTagViewModel } from '@/models/wabunka/wabunkaTag';

// タググループ名には依存させない
export const isThemeTag = (tag: Pick<WabunkaTagViewModel, 'tagGroupType'>): boolean => tag.tagGroupType === 'theme';
